import { Component, OnInit } from '@angular/core';
import { SegurancaService } from '../service/seguranca.service';
import { environment } from 'src/environments/environment';
import { ItemSelecaoContextoQuasar } from '../contexto/selecao-contexto';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
})
export class MenuComponent implements OnInit {

  public dynamicHtml!: SafeHtml;

  constructor(
    private segurancaService: SegurancaService,
    private http: HttpClient,
    private sanitizer: DomSanitizer
    ) { }

  entidade: ItemSelecaoContextoQuasar;
  loading = false;

  ngOnInit() {
    this.getSistemaMenuHtml();
    const contexto = this.segurancaService.getLicenca();
    if(contexto != null){
      this.entidade = contexto;
    }

    const token = this.segurancaService.getWebToken();

    if (token != null && !this.segurancaService.isAuthenticatedQuasar()) {
      this.loading = true; 

      this.segurancaService.loginQuasarProxy().subscribe({
        next: (data: any) => {
          if (data) {
            //Salvar os dados do login na Quasar
            if(data.listaObj){
              let webTokenQuasar = this.segurancaService.getWebToken();
              webTokenQuasar.wsLoginQuasar = data.listaObj[0];
              localStorage.setItem('token', JSON.stringify(webTokenQuasar));
            }else  if(data.errorRest){
              throw Error(data.errorRest.message);
            }            
          }
        },
        error: (err) => {
          console.error('Erro no loginQuasar:', err);
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
        }
      });
    }
    
    
  }

  private getSistemaMenuHtml(): void {
    this.http.get(`./assets/sistemas/${environment.app[window.location.origin].menuHtml}`, { responseType: 'text' })
      .subscribe(htmlContent => {
        this.dynamicHtml = this.sanitizer.bypassSecurityTrustHtml(htmlContent);
      }
    );
  }

  public redirectAppCliente(){
    this.segurancaService.sendToApp();
  }

  public login(){
    this.segurancaService.sendToApp();
  }

}